import { RATING_THRESHOLDS } from "@/pages/CreatorAnalytics/constants";

export const getRatingColor = (rating: number | null): string => {
  if (rating === null) {
    return "";
  }
  if (rating >= RATING_THRESHOLDS.GOOD) {
    return "text-green-500";
  }
  if (rating >= RATING_THRESHOLDS.LOW) {
    return "text-orange-500";
  }
  return "text-red-500";
};
